import { Icon } from '@/icons/Icon'
import { cn } from '@/lib/utils'

const staticOverview = [
  {
    icon: 'subtitles',
    label: 'Subtitles: english',
    group: 'Package',
  },
  {
    icon: 'tv',
    label: 'Online at your own pace',
    group: 'Access',
  },
  {
    icon: 'infinity',
    label: 'Lifetime access',
    group: 'Access',
  },
  {
    icon: 'sack-dollar',
    label: 'Bulk purchase deal',
    group: 'Discount',
  },
]

type CourseOverviewProps = {
  duration?: string | null
  modules?: number | null
  borderless?: boolean
  className?: string
}

export default function CourseOverview({
  duration,
  modules,
  borderless,
  className,
}: CourseOverviewProps) {
  const dynamicItems = []

  if (duration) {
    dynamicItems.push({
      icon: 'clock',
      label: `${duration} of content`,
      group: 'Package',
    })
  }

  if (modules) {
    dynamicItems.push({
      icon: 'book-open',
      label: `${modules} ${modules === 1 ? 'lesson' : 'lessons'}`,
      group: 'Package',
    })
  }

  const overview = [...dynamicItems, ...staticOverview]

  const groupedOverview = overview.reduce(
    (acc, item) => {
      if (!acc[item.group]) {
        acc[item.group] = []
      }
      acc[item.group].push(item)
      return acc
    },
    {} as Record<string, typeof overview>,
  )

  return (
    <div
      className={cn(
        'relative flex overflow-hidden rounded-2xl',
        borderless ? '' : 'border border-gray-200 dark:border-white/10',
        className,
      )}
    >
      <div className="flex w-full flex-col gap-4 py-4 pl-4 pr-6">
        {Object.entries(groupedOverview).map(([group, items]) => (
          <div key={group} className="flex flex-col gap-3">
            <div className="text-13 font-normal leading-none text-gray-500 dark:text-white/60">
              {group}
            </div>
            {items.map((item, index) => (
              <div key={index} className="flex items-center gap-4">
                <Icon name={item.icon} className="text-primary-500" />
                <p className="text-14 text-gray-950 dark:text-white">{item.label}</p>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className="bg-striped flex w-8.5 grow border-l border-gray-200 dark:border-white/10"></div>
    </div>
  )
}
